/* eslint-disable react/no-danger */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';

import * as AppPropTypes from '../../lib/PropTypes';

import { useModal } from '../../contexts/ModalsContext';
import Button from '../buttons/Button';
import PillButton from '../buttons/Pill';
import SearchIcon from '../icons/Search';
import Image from '../partials/Image';
import Link from '../partials/Link';

import styles from '../../../styles/cards/edition.module.scss';

const propTypes = {
    item: AppPropTypes.listItem,
    className: PropTypes.string,
    withoutYear: PropTypes.bool,
};

const defaultProps = {
    item: null,
    className: null,
    withoutYear: false,
};

const EditionCard = ({ item, className, withoutYear }) => {
    const {
        label = null,
        poster = null,
        pages = null,
        archiveUrl = null,
        page: editionPage = null,
    } = item || {};

    const intl = useIntl();

    const finalPage = editionPage || (pages || []).find((it) => it.type === 'edition') || null;
    const { url: editionUrl = null } = finalPage || {};

    const hasLink = editionUrl !== null || archiveUrl !== null;
    const href = hasLink && archiveUrl !== null ? archiveUrl : editionUrl || null;
    const external = href !== null && archiveUrl !== null;

    const linkLabel = external
        ? intl.formatMessage(
              {
                  defaultMessage: 'View archived website for FNC {year}',
                  description: 'Button label',
              },
              { year: label },
          )
        : intl.formatMessage(
              {
                  defaultMessage: 'View edition page for FNC {year}',
                  description: 'Button label',
              },
              { year: label },
          );

    const { setModal } = useModal();
    const setPosterModal = useCallback(
        (e, posterItem) => {
            e.preventDefault();
            setModal({ type: 'poster', item: posterItem });
        },
        [setModal],
    );

    return (
        <div
            className={classNames(styles.container, {
                [className]: className !== null,
            })}
        >
            {poster !== null ? (
                <div className={styles.frame}>
                    <PillButton
                        className={styles.zoomButton}
                        onClick={(e) => setPosterModal(e, poster)}
                        icon={<SearchIcon />}
                        aria-label={intl.formatMessage({
                            defaultMessage: 'Zoom on poster',
                            description: 'Button label',
                        })}
                    />

                    {hasLink ? (
                        <Link
                            href={href}
                            className={styles.link}
                            external={external}
                            aria-label={linkLabel}
                        >
                            <Image className={styles.poster} media={poster} fit cover />
                        </Link>
                    ) : (
                        <Button
                            className={styles.link}
                            onClick={(e) => setPosterModal(e, poster)}
                            aria-label={linkLabel}
                        >
                            <Image className={styles.poster} media={poster} fit cover />
                        </Button>
                    )}
                </div>
            ) : null}

            {!withoutYear ? <h2 className={styles.year}>{label}</h2> : null}
        </div>
    );
};

EditionCard.propTypes = propTypes;
EditionCard.defaultProps = defaultProps;

export default EditionCard;
